import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import Offerings from "@/pages/home/components/Offerings";
import FilmLibrary from "@/pages/home/components/FilmLibrary";
import NinetiesTimeline from "@/pages/home/components/NinetiesTimeline";
import TheaterSchedule from "@/pages/home/components/TheaterSchedule";
import WatchGuide from "@/pages/home/components/WatchGuide";
import EraStats from "@/pages/home/components/EraStats";
import Glossary from "@/pages/home/components/Glossary";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteNav />
      <main className="w-full">
        <Hero />
        <Offerings />
        <FilmLibrary />
        <NinetiesTimeline />
        <TheaterSchedule />
        <WatchGuide />
        <EraStats />
        <Glossary />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}